import React from 'react';
import { Breadcrumbs } from '../../../../../components';
import { LABELS } from '../constants';

type SourceBreadcrumbsProps = {
  knowledgeBaseName?: string;
  knowledgeBaseId: string;
};

export const SourceBreadcrumbs: React.FC<SourceBreadcrumbsProps> = ({
  knowledgeBaseName,
  knowledgeBaseId,
}) => {
  return (
    <Breadcrumbs
      className="mb-lg text-small"
      items={[
        { label: LABELS.KNOWLEDGE, url: '/knowledge_management' },
        {
          label: knowledgeBaseName || knowledgeBaseId,
        },
      ]}
    />
  );
};
